<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar
        title="桌台信息"
        left-text="返回"
        @click-left="onClickLeft"
        left-arrow
        fixed
    />
    <!--导航栏 end-->
    <!--内容部分 start-->
    <van-form ref="forms" style="margin-top: 1.5rem">
      <van-field
          v-model="name"
          label="桌台名称"
          required
          clearable
          :rules="[{ required: true, message: '桌台名称不能为空' }]"
      />
    </van-form>
    <div style="margin: 16px;">
      <van-button @click="onSubmit" round block type="info" native-type="submit">
        修改
      </van-button>
    </div>

    <!--内容部分 end-->
    <div v-if="image" style="padding: 30px">
      <van-image :src="image"></van-image>
      <div style="text-align: center;font-size: 24px;">长按保存图片</div>
    </div>

  </div>
</template>

<script>
// import VueCookie from 'vue-cookies'
import {Notify, Toast} from 'vant';
import Config from "@/config";
export default {
  name: "SeatAdd",
  data() {
    return {
      imageList: [],
      name: '',
      id: 0,
      image: ""
    };
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5';
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = '';
    next();
  },
  created() {
    this.id=this.$route.query.id;
    this.loadInfo()
    this.onDownload()
  },
  methods: {
    loadInfo() {
      this.$http.post('/wechat/api.store_class/seatInfo',{id:this.id}).then(response => {
        if (response && response.body.code== 200) {
          this.name=response.body.data.name
        }
      })
    },
    // 左侧返回
    onClickLeft() {
      this.$router.push("/SeatList");
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      this.$refs.forms.validate().then(() => {
        var toast = Toast.loading({
          duration: 0,
          message: '修改中',
          forbidClick: true,
          loadingType: 'spinner',
        });
        this.$http.post('/wechat/api.store_class/SeatEdit', {
          name: this.name,
          id:this.id,
        }).then(response => {
          toast.clear();
          if (response && response.data.code== 200) {
            this.$router.push("/SeatList");
          }else{
            Notify({type: 'danger', message: response.data.msg});
          }
        })
      }).catch(() => {
        this.$toast.fail('必填项未填写')
      })
    },
    onDownload() {
        this.$http.post('/wechat/api.store_class/seatDownload', {
          id:this.id,
        }).then(response => {
          if (response && response.data.code== 200) {
            this.image = response.data.data.image
          }else{
            Notify({type: 'danger', message: response.data.msg});
          }
        })
    }
  },
}
</script>

<style >
.van-icon-goods-collect-o::before{
  position: relative;
  top: 0.1rem;
}
.van-icon-contact::before{
  position: relative;
  top: 0.1rem;
}

.van-field >>>.van-field__label{
  width: 30px;
}
</style>
